import { render, staticRenderFns } from "./HQApprovalDetail.vue?vue&type=template&id=12a616ff&scoped=true"
import script from "./HQApprovalDetail.vue?vue&type=script&lang=js"
export * from "./HQApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./HQApprovalDetail.vue?vue&type=style&index=0&id=12a616ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a616ff",
  null
  
)

export default component.exports